// Centralized TanStack Query keys. The refetch table in
// frontend-design §6 references these by resource; invalidating one
// invalidates the corresponding cache.

export const qk = {
  session: () => ['session'] as const,

  agreementsList: (q: Record<string, unknown>) =>
    ['agreements', 'list', q] as const,
  agreement: (id: string) => ['agreements', id] as const,
  agreementAuditEvents: (id: string, q: Record<string, unknown>) =>
    ['agreements', id, 'audit', q] as const,

  agreementAssignments: (agreementId: string) =>
    ['agreements', agreementId, 'assignments'] as const,
  assignmentCredits: (assignmentId: string) =>
    ['assignments', assignmentId, 'credits'] as const,

  agreementMilestones: (agreementId: string) =>
    ['agreements', agreementId, 'milestones'] as const,
  milestoneAllocations: (milestoneId: string) =>
    ['milestones', milestoneId, 'allocations'] as const,

  myAssignments: (q: Record<string, unknown>) =>
    ['me', 'assignments', q] as const,

  companies: (q: Record<string, unknown>) => ['companies', 'list', q] as const,
  companiesAll: () => ['companies'] as const,
  people: (q: Record<string, unknown>) => ['people', 'list', q] as const,
  peopleAll: () => ['people'] as const,

  dashboardAgreementsByStatus: () => ['dashboard', 'agreements-by-status'] as const,
  dashboardActiveValue: () => ['dashboard', 'active-value'] as const,
  dashboardTeamUtilization: (q: Record<string, unknown>) =>
    ['dashboard', 'team-utilization', q] as const,
  dashboardEndingSoon: (q: Record<string, unknown>) =>
    ['dashboard', 'ending-soon', q] as const,
};
